module.exports = __webpack_public_path__ + "img/nwf.5fa6ede2.svg";